<!-- Floating ReadSpeaker Toggle Button -->
<button class="rs-floating-btn" (click)="toggleRead()">
  <i class="fas fa-volume-up"></i>
</button>

<app-accessibility></app-accessibility>

<div id="contentToRead">
  <router-outlet></router-outlet>
</div>